export enum JobStatus {
  template = 0,
  pending = 1, // awaiting parse
  active = 2,
  finished = 3,
  stopped = 4,
  imported = 5,
  deleted = 9,
}
